import type { DefaultOptionType } from 'antd/es/select';
import { I18n } from '@aws-amplify/core';
import type {
	GetErgonomicToolListRequestDTO,
	GetErgonomicToolListResponseDTO
} from '@/core/dto/ergonomic-tool/get-ergonomic-tool-list';

export class GetErgonomicToolListMapper {
	constructor(private readonly data: GetErgonomicToolListResponseDTO = []) {}

	static toDTO(values: any): GetErgonomicToolListRequestDTO {
		return {
			organization_id: values.organization_id,
			company_id: values.company_id,
			sector_id: values.sector_id,
			line_id: values.line_id,
			workstation_id: values.workstation_id,
			extraction_name: values.name,
			start_date: values.initial_date,
			end_date: values.final_date,
			custom_report_id: values.report_type_id,
			ergonomic_tool_ids: values.ergonomic_tool_id,
			action_plan_types: values.action_plan_status,
			limit: values.limit,
			offset: values.page
		};
	}

	toDomain(): DefaultOptionType[] {
		return this.data.map((value) => ({
			value: value.id,
			label: I18n.get(value.title),
			key: value.description.replace('-', '_') 
		}));
	}
}
